/**
 * Sticky Add to Cart Module
 * Desktop: Sticky bar appears after user scrolls below product CTA
 * Mobile: Fixed bottom CTA bar
 */

class StickyAddToCart {
  constructor() {
    this.stickyBar = null;
    this.productCTA = null;
    this.scrollTimeout = null;
    this.isVisible = false;
    this.isDesktop = window.innerWidth >= 993;
    this.init();
  }

  init() {
    // Only init on product pages
    if (!document.querySelector('[data-product-form]')) {
      return;
    }

    this.createStickyBar();
    this.attachEventListeners();
  }

  createStickyBar() {
    this.stickyBar = document.createElement('div');
    this.stickyBar.className = 'sticky-add-to-cart';
    this.stickyBar.innerHTML = `
      <div class="sticky-add-to-cart-container">
        <div class="sticky-add-to-cart-product">
          <img 
            id="sticky-product-image"
            src="" 
            alt="Product"
            class="sticky-product-image"
          >
          <div class="sticky-product-info">
            <h3 id="sticky-product-title" class="sticky-product-title"></h3>
            <p id="sticky-product-price" class="sticky-product-price"></p>
          </div>
        </div>

        <div class="sticky-add-to-cart-actions">
          <div class="sticky-quantity-selector">
            <button class="qty-btn" id="sticky-qty-minus">−</button>
            <input type="number" id="sticky-qty-input" value="1" min="1">
            <button class="qty-btn" id="sticky-qty-plus">+</button>
          </div>
          <button class="button button-accent" id="sticky-add-to-cart-btn">Add to Cart</button>
          <button class="sticky-close-btn" aria-label="Close sticky bar">✕</button>
        </div>
      </div>
    `;
    document.body.appendChild(this.stickyBar);
  }

  attachEventListeners() {
    // Scroll detection (desktop only)
    if (this.isDesktop) {
      window.addEventListener('scroll', () => this.onScroll());
    }

    // Quantity controls
    document.getElementById('sticky-qty-minus').addEventListener('click', () => this.decreaseQty());
    document.getElementById('sticky-qty-plus').addEventListener('click', () => this.increaseQty());

    // Add to cart
    document.getElementById('sticky-add-to-cart-btn').addEventListener('click', (e) => this.addToCart(e));

    // Close button
    document.querySelector('.sticky-close-btn').addEventListener('click', () => this.hideStickyBar());

    // Product data observer
    this.updateProductData();

    // Responsive listener
    window.addEventListener('resize', () => {
      const newIsDesktop = window.innerWidth >= 993;
      if (newIsDesktop !== this.isDesktop) {
        this.isDesktop = newIsDesktop;
      }
    });
  }

  updateProductData() {
    const productForm = document.querySelector('[data-product-form]');
    if (!productForm) return;

    // Extract product data
    const productTitle = document.querySelector('[data-product-title]')?.textContent || 'Product';
    const productPrice = document.querySelector('[data-product-price]')?.textContent || '$0.00';
    const productImage = document.querySelector('[data-product-image]')?.src || '/placeholder.svg';

    // Update sticky bar
    document.getElementById('sticky-product-title').textContent = productTitle;
    document.getElementById('sticky-product-price').textContent = productPrice;
    document.getElementById('sticky-product-image').src = productImage;
  }

  onScroll() {
    const productCTA = document.querySelector('[data-product-cta]');
    if (!productCTA) return;

    clearTimeout(this.scrollTimeout);
    
    this.scrollTimeout = setTimeout(() => {
      const ctaRect = productCTA.getBoundingClientRect();
      
      // Show sticky bar if CTA is above viewport (user scrolled past it)
      if (ctaRect.bottom < 0) {
        this.showStickyBar();
      } else {
        this.hideStickyBar();
      }
    }, 100);
  }

  showStickyBar() {
    if (this.isVisible) return;
    
    this.stickyBar.classList.add('active');
    this.isVisible = true;
  }

  hideStickyBar() {
    if (!this.isVisible) return;
    
    this.stickyBar.classList.remove('active');
    this.isVisible = false;
  }

  decreaseQty() {
    const input = document.getElementById('sticky-qty-input');
    const current = parseInt(input.value);
    if (current > 1) {
      input.value = current - 1;
    }
  }

  increaseQty() {
    const input = document.getElementById('sticky-qty-input');
    const current = parseInt(input.value);
    input.value = current + 1;
  }

  async addToCart(e) {
    e.preventDefault();

    const quantity = parseInt(document.getElementById('sticky-qty-input').value);
    const variantId = document.querySelector('[data-variant-id]')?.value;

    if (!variantId) {
      console.error('[StickyAddToCart] No variant ID found');
      return;
    }

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: variantId,
          quantity: quantity
        })
      });

      if (response.ok) {
        // Show success feedback
        const btn = document.getElementById('sticky-add-to-cart-btn');
        const originalText = btn.textContent;
        btn.textContent = 'Added!';
        btn.disabled = true;

        // Trigger cart drawer
        if (window.cartDrawer) {
          window.cartDrawer.openDrawer();
          window.cartDrawer.fetchCart();
        }

        setTimeout(() => {
          btn.textContent = originalText;
          btn.disabled = false;
          document.getElementById('sticky-qty-input').value = 1;
        }, 2000);
      }
    } catch (error) {
      console.error('[StickyAddToCart] Error adding to cart:', error);
    }
  }

  // Show sticky bar on mobile by default
  initMobileSticky() {
    if (window.innerWidth < 993) {
      this.showStickyBar();
    }
  }
}

// Initialize on product pages
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    window.stickyAddToCart = new StickyAddToCart();
    window.stickyAddToCart.initMobileSticky();
  });
} else {
  window.stickyAddToCart = new StickyAddToCart();
  window.stickyAddToCart.initMobileSticky();
}
